import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

function checkLang() {
  const supportedLocales = ['it', 'en', 'de']
  let locale = window.configBC.lang || process.env.VUE_APP_LANG || 'en'
  locale = locale.toLowerCase()
  return supportedLocales.find(el => el === locale) || 'it'
}

export default new VueI18n({
  locale: checkLang(),
  fallbackLocale: window.configBC.lang || process.env.VUE_APP_LANG || 'en',
  messages: loadLocaleMessages()
})
